'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { setDefaultOptions } from 'date-fns';
import { sv, enAU } from 'date-fns/locale';
import { useParams } from 'next/navigation';

const axeptioId = process.env.NEXT_PUBLIC_AXEPTIO_ID;

export function LayoutScripts() {
  const { locale } = useParams();

  useEffect(() => {
    if (locale === 'sv') {
      setDefaultOptions({ locale: sv });
    } else {
      setDefaultOptions({ locale: enAU });
    }
  }, [locale]);

  return (
    <>
      {axeptioId && (
        <Script
          id="axeptio-consent"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
                        void 0 === window._axcb && (window._axcb = []);
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}

                        window._axcb.push(function (axeptio) {
                            axeptio.on("ready", function (choices) {
                                gtag('consent', 'default', {
                                    'analytics_storage': 'denied',
                                    'ad_storage': 'denied',
                                    'ad_user_data': 'denied',
                                    'ad_personalization': 'denied',
                                });
                            });
                            axeptio.on("cookies:complete", function (choices) {
                                gtag('consent', 'default', {
                                    'analytics_storage': choices.$$googleConsentMode.analytics_storage ? 'granted' : 'denied',
                                    'ad_storage': choices.$$googleConsentMode.ad_storage ? 'granted' : 'denied',
                                    'ad_user_data': choices.$$googleConsentMode.ad_user_data ? 'granted' : 'denied',
                                    'ad_personalization': choices.$$googleConsentMode.ad_personalization ? 'granted' : 'denied',
                                });
                                if (choices && choices.$$googleConsentMode && window.loadHotjar) {
                                    window.loadHotjar();
                                }
                            });
                        });
                        `,
          }}
        />
      )}
    </>
  );
}
